// extracted by mini-css-extract-plugin
export default {"left_box":"index_left_box_YeLKv","dbox":"index_dbox_-VxAT","adBox":"index_adBox_C2tnD"};